import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { parseJwt } from 'utils/parseJwt'
import { useTokenExpiryHandler } from 'store/contexts/TokenExpWarn'

export const TOKEN_PREFIX = 'token'

const AuthVerify = () => {
  const history = useHistory()
  const { handleExpiredTokenWarning } = useTokenExpiryHandler()

  useEffect(() => {
    // Listen for every route change and verify the token is still valid.
    // If the token is present and unexpired, the user continues uninterrupted.
    // If it has expired, show the session-expired warning which handles
    // unlock + re-login without any hard redirect.
    const unlisten = history.listen(() => {
      const token = localStorage.getItem(TOKEN_PREFIX)

      if (!token) return

      const decodedJwt = parseJwt(token)
      if (decodedJwt && decodedJwt.exp * 1000 < Date.now()) {
        handleExpiredTokenWarning()
      }
    })

    return () => {
      unlisten()
    }
  }, [history, handleExpiredTokenWarning])

  return <div data-testid="auth-verify"></div>
}

export default AuthVerify
